import Link from 'next/link';
import Image from 'next/image';
import clearHtml from '@/utils/clearHtmlElements';
import withLazyLoad from '../../hooks/withLazyLoad';

function RelatedPosts({ relatedPosts, relatedVideoTag }) {
    const relatedPostsText = relatedVideoTag ? 'Related Videos' : 'Related Articles';

    return (
        <div className="related-post-container px-0 py-5 print:hidden">
            <h2 className={`text-center`}>{relatedPostsText}</h2>
            <div className="mt-10 flex w-full flex-wrap justify-center md:columns-3 md:flex-nowrap lg:mt-auto">
                {relatedPosts.map((post, index) => {
                    const { featuredImage, uri, title } = post;
                    const node = featuredImage?.node;
                    const sourceUrl = node?.sourceUrl || `/images/image-placeholder.png`;
                    return (
                        <Link className="text-black" hrefLang="en" title={clearHtml(title)} key={index} href={uri}>
                            <div className="background-white mx-0 mb-0 mt-2.5 max-w-[320px] text-center xsm:mx-6 md:mx-2.5 md:mt-10 2xl:mx-5">
                                <Image src={sourceUrl} alt={node?.altText} width="320" height="179" style={{ contain: 'size' }} />
                                <div className="px-2.5 py-5 dark:text-white">
                                    <h5 className="mt-0" dangerouslySetInnerHTML={{ __html: title }} />
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}

export default withLazyLoad(RelatedPosts);
